import { Avatar, LinearProgress, Stack, Typography } from '@mui/material';
import { DICTIONARY } from 'Enum';
import { Dictionary } from 'Dictionary';
import { GreenCheckMark } from 'Images';
import { useIsDesktop } from 'Hooks';
export interface IProgressBar {
  value?: number;
}

export const ProgressBar = (props: IProgressBar & { showComment: boolean }) => {
  const filledValue = 100;
  const notFilledValue = 0;

  const isUndefined = props.value === undefined;

  const isDesktop = useIsDesktop();

  const progressBarMsg = () => {
    if (props.showComment)
      return Dictionary[DICTIONARY.STATUS_LOBBY].progressBarAllMandatoryFilled;
    if (props.value === filledValue)
      return Dictionary[DICTIONARY.STATUS_LOBBY].progressBarAllFilled;
    if (props.value === notFilledValue || isUndefined)
      return Dictionary[DICTIONARY.STATUS_LOBBY].progressBarNotFilled;
    return Dictionary[DICTIONARY.STATUS_LOBBY].progressBarPartiallyFilled;
  };

  return (
    <Stack gap={1} mb={1} alignItems='center'>
      <LinearProgress
        variant='determinate'
        sx={{ width: '96%', borderRadius: '3px', height: '6px' }}
        value={isUndefined ? notFilledValue : props.value}
        aria-hidden='true'
      />
      <Stack
        direction='row'
        justifyContent='center'
        alignItems='center'
        gap='4px'
      >
        {props.value === filledValue && (
          <Avatar
            alt=''
            src={GreenCheckMark}
            sx={
              isDesktop
                ? { width: '15px', height: '18px' }
                : { width: '12px', height: '15px' }
            }
          />
        )}
        <Typography variant='subtitle1' color='#60727E'>
          {progressBarMsg()}
        </Typography>
      </Stack>
    </Stack>
  );
};
